const tools = require('../../tools')

exports.getFacilityQTOData = getFacilityQTOData
async function getFacilityQTOData (
  state,
  mainApi,
  { locationId, programId, date } = {}
) {
  tools.validateParams('getFacilityQTOData', arguments[2])

  const [location, stockReports, forecastData] = await Promise.all([
    mainApi.location.get(locationId, date),
    mainApi.report.list({ locationId, programId, limit: 1 }),
    mainApi.forecast.get(locationId, programId)
  ])

  const latestReport = stockReports[0]
  const stockProducts = latestReport ? latestReport.products : {}
  const forecastProducts = forecastData.products

  const allProductIds = new Set([
    ...Object.keys(stockProducts),
    ...Object.keys(forecastProducts)
  ])

  const products = {}
  for (const productId of allProductIds) {
    const stock = stockProducts[productId]
    const forecast = forecastProducts[productId]
    products[productId] = {
      soh: stock ? Number(stock.soh) : 0,
      consumed: stock ? Number(stock.consumed) : 0,
      ...(forecast && {
        dailyDemand: forecast.dailyDemand,
        minLevel: forecast.minLevel,
        reorderPoint: forecast.reorderPoint,
        maxLevel: forecast.maxLevel,
        leadTimeDays: forecast.leadTimeDays,
        safetyStock: forecast.safetyStock
      })
    }
  }

  return {
    location,
    products,
    reports: latestReport ? [{ _id: latestReport.id }] : []
  }
}
